import React from 'react';
import PropTypes from 'prop-types';

export default function IconAccept({ className }) {
  return (
    <svg className={className} fill="none" height="16" viewBox="0 0 16 16" width="16" xmlns="http://www.w3.org/2000/svg">
      <path d="M8 0.5C3.86 0.5 0.5 3.86 0.5 8C0.5 12.14 3.86 15.5 8 15.5C12.14 15.5 15.5 12.14 15.5 8C15.5 3.86 12.14 0.5 8 0.5ZM8 14C4.6925 14 2 11.3075 2 8C2 4.6925 4.6925 2 8 2C11.3075 2 14 4.6925 14 8C14 11.3075 11.3075 14 8 14ZM10.91 5.2175L6.5 9.6275L5.09 8.2175C4.7975 7.925 4.325 7.925 4.0325 8.2175C3.74 8.51 3.74 8.9825 4.0325 9.275L5.975 11.2175C6.2675 11.51 6.74 11.51 7.0325 11.2175L11.975 6.275C12.2675 5.9825 12.2675 5.51 11.975 5.2175C11.6825 4.925 11.2025 4.925 10.91 5.2175V5.2175Z" fill="white"/>
    </svg>
  );
}

IconAccept.propTypes = {
  className: PropTypes.string
};

